import { render, staticRenderFns } from "./quadroHonra-detalhes.vue?vue&type=template&id=4ba37c29&"
import script from "./quadroHonra-detalhes.vue?vue&type=script&lang=js&"
export * from "./quadroHonra-detalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports